import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import PressArticle from './PressArticle';
import { pressArticles } from 'consts';
import { CarouselContainer } from './styles';
import themed from 'components/hoc/themed';

const PressCarousel = () => {
  const responsiveConfig = {
    0: { items: 1 },
    700: { items: 2 },
    1024: { items: 4 },
  };
  const carouselItems = [
    <PressArticle key={0} {...pressArticles[0]} />,
    <PressArticle key={1} {...pressArticles[1]} />,
    <PressArticle key={2} {...pressArticles[2]} />,
    <PressArticle key={3} {...pressArticles[3]} />,
  ];
  return (
    <CarouselContainer className="carousel mt-3 mb-3">
      <AliceCarousel
        responsive={responsiveConfig}
        infinite={false}
        mouseDragEnabled
        buttonsDisabled={true}
        items={carouselItems}
        stagePadding={{
          paddingLeft: 0,
          paddingRight: 0,
        }}
      />
    </CarouselContainer>
  );
};

export default themed(PressCarousel);
